export enum Mode {
    Local,
    Host,
    Join
}